module.exports = __webpack_public_path__ + "img/gunRight.941729d8.svg";